import React, { type FC } from 'react'

import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'

import { DeviceForProvisionFields } from './DeviceForProvisionFields'

import {
  deleteDeviceForProvision,
  EditedDeviceForProvisionChangedAction,
  SetEditDeviceDialogStateAction,
  updateDeviceForProvision
} from '../../../redux/admin/admin-device-provisions-actions'

import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type DeviceForProvision } from '../../../redux/admin/admin-device-provisions-types'
import { type RootState } from '../../../redux/store'

export const EditDeviceForProvisionDialog: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const editedDeviceForProvision = useAppSelector((state: RootState) => state.adminDeviceProvisions.editedDeviceForProvision)
  const editDeviceForProvisionDialogOpen = useAppSelector<boolean>((state: RootState) => state.adminDeviceProvisions.editDeviceForProvisionDialogOpen)

  const closeDialog = (): void => {
    dispatch(SetEditDeviceDialogStateAction({ isOpen: false }))
  }

  const disabled = (): boolean => {
    return (editedDeviceForProvision.serialNumber === '') ||
            editedDeviceForProvision.devEUI === '' ||
            editedDeviceForProvision.appEUI === '' ||
            editedDeviceForProvision.appKey === '' ||
            editedDeviceForProvision.deviceProfileId === ''
  }

  const onUpdate = (): void => {
    dispatch(updateDeviceForProvision(
      editedDeviceForProvision.id,
      {
        devEUI: editedDeviceForProvision.devEUI,
        serialNumber: editedDeviceForProvision.serialNumber,
        appEUI: editedDeviceForProvision.appEUI,
        appKey: editedDeviceForProvision.appKey,
        deviceProfileId: editedDeviceForProvision.deviceProfileId
      })).catch(err => {
      console.error('updating device for provision error: ', err)
    })
  }

  const onDelete = (): void => {
    const confirmMessage: string = t('settings_dialog.delete_confirmation_short')
    if (window.confirm(confirmMessage ?? 'confirm deletion')) {
      dispatch(deleteDeviceForProvision(editedDeviceForProvision.id)).catch(err => {
        console.error('deleting device for provision error: ', err)
      })
    }
  }

  const valueChanged = (field: keyof DeviceForProvision, value: string): void => {
    dispatch(EditedDeviceForProvisionChangedAction({
      ...editedDeviceForProvision,
      [field]: value
    }))
  }

  return (
        <Dialog
            open={editDeviceForProvisionDialogOpen}
        >
            <DialogTitle>
                {t('settings_dialog.edit_meter')}
            </DialogTitle>
            <DialogContent>
                <DeviceForProvisionFields
                    deviceForProvision={editedDeviceForProvision}
                    valueChanged={valueChanged}
                />
            </DialogContent>
            <DialogActions>
                <Button key="delete" color="inherit"
                        onClick={() => {
                          onDelete()
                        }}>{t('settings_dialog.delete')}</Button>,
                <Button key="cancel" color="primary"
                        onClick={() => {
                          closeDialog()
                        }}>{t('settings_dialog.cancel')}</Button>,
                <Button
                    key="save"
                    disabled={disabled()}
                    onClick={() => {
                      onUpdate()
                    }}
                    color="secondary"
                >{t('settings_dialog.ok')}
                </Button>
            </DialogActions>
        </Dialog>
  )
}
